import { graphql } from '@/generated/gql';

export const OVERRIDE_AUTOMATIC_ACCEPTANCE_TIMING_MUTATION = graphql(/* GraphQL */ `
  mutation OverrideAutomaticAcceptanceTiming($data: TsrctOverrideAutomaticAcceptanceTimingInput!) {
    tesseract {
      overrideAutomaticAcceptanceTiming(data: $data) {
        targetId
        variant
        source
        plannedAt
        timing {
          reactionMinMinutes
          reactionMaxMinutes
          workingDays
          workingHours {
            start
            end
          }
          timezone
          holiday {
            country
            state
          }
        }
      }
    }
  }
`);
